import $http from "../../axios";
import { Notification } from "element-ui";

export async function fetchSellers({ commit, state }, text) {
    let params = { filter: text };
    console.log(new Date() + "Empezando Sellers");
    await $http
        .get("/api/lista-vendedores", { params })
        .then(response => {
            commit("setSellers", response.data.data);
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
        });
}

export async function getCommisionSaleBrand({ state, commit }, params) {
    state.params.date_from = params.date_from;
    state.params.date_up = params.date_up;
    state.params.seller_id = params.seller_id;
    state.params.branchoffice_id = localStorage.selected_branchoffice;

    await $http
        .get("/api/consulta-comisiones-venta-marca", { params: state.params })
        .then(response => {
            commit("setCommisionSaleBrands", response.data);
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 2000,
                customClass: "notification-box"
            });
        });
    state.loading.commisionSaleBrands = false;
}

export function getSubscriber({ state, commit }) {
    return new Promise(function(resolve, reject) {
        $http
            .get("/api/suscriptor")
            .then(function(response) {
                resolve(response.data.data);
            })
            .catch(function(error) {
                Notification.error({
                    title: "Error!",
                    message: error.message,
                    type: "error",
                    duration: 2000,
                    customClass: "notification-box"
                });

                reject(error);
            });
    });
}

export function updateSubscriber({ state, commit }, data) {
    return new Promise(function(resolve, reject) {
        $http
            .put("/api/suscriptor-lite", data)
            .then(function(response) {
                Notification.success({
                    title: "Exito!",
                    message: 'Actualizado',
                    type: "success",
                    duration: 2000,
                    customClass: "notification-box"
                });
                resolve(response.data.data);
            })
            .catch(function(error) {
                Notification.error({
                    title: "Error!",
                    message: error.message,
                    type: "error",
                    duration: 2000,
                    customClass: "notification-box"
                });

                reject(error);
            });
    });
}



// WEBPACK FOOTER //
// ./src/modules/commission-sale-brand/actions.js